import { render, staticRenderFns } from "./SectionPanels.vue?vue&type=template&id=4668b96e&scoped=true"
import script from "./SectionPanels.vue?vue&type=script&lang=js"
export * from "./SectionPanels.vue?vue&type=script&lang=js"
import style0 from "./SectionPanels.vue?vue&type=style&index=0&id=4668b96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668b96e",
  null
  
)

export default component.exports